import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
        <ul className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/diagram-generator" className="nav-link" onClick={closeMenu}>
              Diagram Generator
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/plantuml-service" className="nav-link" onClick={closeMenu}>
              PlantUML Service
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/mermaid-service" className="nav-link" onClick={closeMenu}>
              Mermaid Service
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/architecture-design" className="nav-link" onClick={closeMenu}>
              Architecture Design
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/process-flows" className="nav-link" onClick={closeMenu}>
              Process Flows
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;